function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_9",
  "data-name": "Path 9",
  d: "M55.379,5.36q-1.073,0-1.073.877V20.862q0,3.072,1.95,4.242a12.082,12.082,0,0,0,5.8,1.12A11.781,11.781,0,0,0,67.81,25.1q2-1.17,2-4.242V6.237q0-.878-1.463-.877V4.482h7.8V5.36q-1.17,0-1.17.877V20.62a11.984,11.984,0,0,1-.829,4.777,6.93,6.93,0,0,1-2.486,2.974,10.11,10.11,0,0,1-4.144,1.511,36.17,36.17,0,0,1-5.654.39,37.142,37.142,0,0,1-5.7-.39,10.061,10.061,0,0,1-4.1-1.511A6.937,6.937,0,0,1,49.578,25.4a11.983,11.983,0,0,1-.83-4.777V6.237q0-.878-1.364-.877V4.482h7.995V5.36ZM94.9,8.675a12.251,12.251,0,0,0-3.706.585,11.323,11.323,0,0,0-3.363,1.706,8.625,8.625,0,0,0-2.39,2.681,7.2,7.2,0,0,0-.925,3.657,7.189,7.189,0,0,0,.926,3.656,9.177,9.177,0,0,0,2.389,2.73,12.014,12.014,0,0,0,3.363,1.657,12.025,12.025,0,0,0,7.41,0,11.323,11.323,0,0,0,3.315-1.657,8.908,8.908,0,0,0,2.438-2.73,7.2,7.2,0,0,0,.926-3.656,7.2,7.2,0,0,0-.926-3.657,8.364,8.364,0,0,0-2.438-2.68A10.677,10.677,0,0,0,98.6,9.26,12.244,12.244,0,0,0,94.9,8.675Zm0-4.485a19.019,19.019,0,0,1,5.459.829,16.521,16.521,0,0,1,5.07,2.388,12.972,12.972,0,0,1,3.754,4.095,11.071,11.071,0,0,1,1.463,5.8,11.331,11.331,0,0,1-1.463,5.85,13.151,13.151,0,0,1-3.754,4.046,15.71,15.71,0,0,1-5.07,2.34,20.756,20.756,0,0,1-10.92,0,15.73,15.73,0,0,1-5.07-2.34,13.159,13.159,0,0,1-3.753-4.046,11.331,11.331,0,0,1-1.463-5.85,11.068,11.068,0,0,1,1.463-5.8,12.981,12.981,0,0,1,3.753-4.095,16.542,16.542,0,0,1,5.07-2.388,19.033,19.033,0,0,1,5.46-.83Zm21.66,17.891.487.244a1.547,1.547,0,0,0,.195.78,3.679,3.679,0,0,0,1.317,1.17,16.838,16.838,0,0,0,2.291.975,24.054,24.054,0,0,0,2.73.731,15.019,15.019,0,0,0,2.535.244q.828,0,2.145-.1a14.007,14.007,0,0,0,2.584-.536,7.256,7.256,0,0,0,2.193-1.072,2.135,2.135,0,0,0,.927-1.8,1.807,1.807,0,0,0-.878-1.658,6.036,6.036,0,0,0-2.242-.78,21.543,21.543,0,0,0-3.169-.292q-1.755-.1-3.608-.244a34.1,34.1,0,0,1-3.656-.487,10.791,10.791,0,0,1-3.169-1.122A6.876,6.876,0,0,1,115,15.939a7.164,7.164,0,0,1-.829-3.657,6.966,6.966,0,0,1,.683-2.973,7.459,7.459,0,0,1,2.193-2.584,11.576,11.576,0,0,1,3.705-1.8,17.041,17.041,0,0,1,5.265-.731,22.57,22.57,0,0,1,4.485.39,31.39,31.39,0,0,1,3.267.829q1.413.438,2.34.828a4.551,4.551,0,0,0,1.608.39,1.345,1.345,0,0,0,.975-.292l.585.39-3.363,6.094-.488-.195a2.688,2.688,0,0,0-.39-1.122,3.884,3.884,0,0,0-1.316-1.12,9.72,9.72,0,0,0-2.1-1.025,15.583,15.583,0,0,0-2.633-.682,13.918,13.918,0,0,0-2.827-.293,13.654,13.654,0,0,0-2.243.195,9.444,9.444,0,0,0-2.047.488,4.606,4.606,0,0,0-1.56.926,1.772,1.772,0,0,0-.585,1.365,2.007,2.007,0,0,0,.828,1.755,6.469,6.469,0,0,0,2.243.878,21.639,21.639,0,0,0,3.169.39q1.8.1,3.656.243a26.136,26.136,0,0,1,3.607.537,9.4,9.4,0,0,1,3.169,1.17,5.926,5.926,0,0,1,2.243,2.145,6.484,6.484,0,0,1,.877,3.558,6.183,6.183,0,0,1-1.365,4.144,9.2,9.2,0,0,1-3.315,2.535,15.618,15.618,0,0,1-4.339,1.268,33.97,33.97,0,0,1-4.29.292,31.51,31.51,0,0,1-4.68-.292,21.877,21.877,0,0,1-3.12-.78q-1.218-.488-1.95-.83a2.791,2.791,0,0,0-1.267-.39.81.81,0,0,0-.634.39l-.682-.39,2.681-5.9Z",
  fill: "#3f3f3f"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_5",
  "data-name": "Rectangle 5",
  width: 21.818,
  height: 21.818,
  rx: 2,
  transform: "translate(6.09 6.091)",
  fill: "none",
  stroke: "#3f3f3f",
  strokeWidth: 4
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_6",
  "data-name": "Rectangle 6",
  width: 9.545,
  height: 9.545,
  rx: 2,
  transform: "translate(2 2)",
  fill: "#f9f9f9",
  stroke: "#3f3f3f",
  strokeWidth: 4
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7",
  "data-name": "Rectangle 7",
  width: 9.545,
  height: 9.545,
  rx: 2,
  transform: "translate(2 22.454)",
  fill: "#f9f9f9",
  stroke: "#3f3f3f",
  strokeWidth: 4
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_8",
  "data-name": "Rectangle 8",
  width: 9.545,
  height: 9.545,
  rx: 2,
  transform: "translate(22.456 2)",
  fill: "#f9f9f9",
  stroke: "#3f3f3f",
  strokeWidth: 4
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_9",
  "data-name": "Rectangle 9",
  width: 9.545,
  height: 9.545,
  rx: 2,
  transform: "translate(22.456 22.454)",
  fill: "#f9f9f9",
  stroke: "#3f3f3f",
  strokeWidth: 4
});

function SvgLoginLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "LoginLogo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 139.521,
    height: 33.999,
    viewBox: "0 0 139.521 33.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLogo);
export default __webpack_public_path__ + "static/media/LoginLogo.07532e42.svg";
export { ForwardRef as ReactComponent };